import React, { createContext, FunctionComponent, ReactNode, useContext } from 'react';

const ScopeContext = createContext('main');

export interface ScopeProps {
  scope: string;
  children: ReactNode;
}

const Scope: FunctionComponent<ScopeProps> = ({ scope, children }) => (
  <ScopeContext.Provider value={scope}>{children}</ScopeContext.Provider>
);

export default Scope;

export function useScope(): string {
  return useContext(ScopeContext);
}
